'use client'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

const AccessibilityFourthSection = () => {
  const translate = useTranslate('accessibility.fourth-section')

  return (
    <section className="accessibility-landingpage__fourth-section">
      <p
        className="accessibility-landingpage__fourth-section-body"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: translate('body') }}
      />
    </section>
  )
}

export default AccessibilityFourthSection
